import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'approximate_number_of_supervisors_2'

export const dataPointDefinition = {
  retracedId: 'approximate_number_of_supervisors_2',
  name: 'Approximate number of supervisors',
  description:
    'Supervisors are persons who lead or supervise others and who work on the production floor (not in the office), e.g., line leaders, group leaders, and department heads, but not managers.',
  meta: {
    slcpMeta: {
      key: 'fp-nat-13',
      number: 'FP-NAT-10',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-nat-13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27790,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
